import React from 'react'

export default class IconsMainNavEmail extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M14.6667 4.66669L8.67268 8.48469C8.46927 8.60283 8.23823 8.66506 8.00301 8.66506C7.76779 8.66506 7.53675 8.60283 7.33334 8.48469L1.33334 4.66669'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M13.3333 2.66669H2.66668C1.9303 2.66669 1.33334 3.26364 1.33334 4.00002V12C1.33334 12.7364 1.9303 13.3334 2.66668 13.3334H13.3333C14.0697 13.3334 14.6667 12.7364 14.6667 12V4.00002C14.6667 3.26364 14.0697 2.66669 13.3333 2.66669Z'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
